import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "boxicons/css/boxicons.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import ChatBot from "react-simple-chatbot";
import Joke from "./components/chatbot-options/Joke";
import GithubStats from "./components/chatbot-options/GithubStats";
import Wiki from "./components/chatbot-options/Wiki";
import Navigation from "./components/navigation/Navigation";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Projects from "./components/pages/Projects";
import SocialAcc from "./components/social-account/SocialAcc";

function App() {

  // useEffect(() => {
  //   document.addEventListener('contextmenu', (e) => {
  //     e.preventDefault();
  //   });
  // });

  return (
    <>
      <Navigation />
      <div className="container-fluid">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/about-me" element={<About />} />
          <Route path="/my-works" element={<Projects />} />
          {/* <Route path="/contact" element={<ContactMe />} /> */}
          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>

        <SocialAcc />

        {/* Chatbot */}
        <ChatBot
          headerTitle="Herminigildo Jr (Lasyanga)"
          floating={true}
          // hideUserAvatar={true}
          // speechSynthesis={{ enable: true, lang: "en" }}
          style={{
            textDecoration: "none",
          }}
          steps={[
            {
              id: "greetings",
              message: "Hello there!",
              trigger: "1",
            },
            {
              id: "1",
              message: "My name is Herminigildo Jr.",
              trigger: "4",
            },
            {
              id: "4",
              message: "How can I assist you?",
              trigger: "5",
            },
            {
              id: "5",
              options: [
                {
                  value: 1,
                  label: "Lasyanga's Github stats",
                  trigger: "github-stats",
                },
                // { value: 2, label: "Search on Wikidepdia", trigger: "search" },
                { value: 3, label: "Tell a Joke", trigger: "joke" },
              ],
            },
            {
              id: "joke",
              component: <Joke />,
              // asMessage: true,
              trigger: "4",
            },
            {
              id: "search",
              message: "What can I search on Wikipedia?(Ex. Chatbot)",
              trigger: "toSearch",
            },
            {
              id: "toSearch",
              user: true,
              trigger: "result",
            },
            {
              id: "result",
              component: <Wiki />,
              // asMessage: true,
              trigger: "4",
            },
            {
              id: "github-stats",
              component: <GithubStats />,
              // asMessage:true,
              trigger: "4",
            },
          ]}
        />
      </div>
    </>
  );
}

export default App;
